import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import type { RootState } from '@store/store'

type UsersState = {
  currentUserId: number | null
}
const initialState: UsersState = {
  currentUserId: null,
}

// Slice
const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setCurrentUserId: (state, action: PayloadAction<number>) => {
      state.currentUserId = action.payload
    },
  },
})

// Selectors
export const selectCurrentUserId = (s: RootState) => s.users.currentUserId

// Actions
export const { setCurrentUserId } = usersSlice.actions
export const usersReducer = usersSlice.reducer
